import { useTheme } from '@mui/material/styles';
import WiseShiftLogo from '../../assets/images/WiseShift.png';


export default function LogoMain() {
  const theme = useTheme();
  return (
    <>
      <img
        src={WiseShiftLogo}
        alt="WiseShift Logo"
        width={158}
        height={55}
        style={{ objectFit: 'contain' }}
      />
    </>
  );
}
